{
	"AboutUs": {
		"index": 0
	},
	"Features About": {
		"Feature 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {}
		},
		"Feature 01 Image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": "Lawyer on a phone walking a dog on a sidewalk in front of a building"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fabout%20us%2FFeatures%20About%2FFeature%2001%20Image%2FL-Cole-2023-8916-copy.jpg?alt=media&token=d86e5780-f350-4585-aded-1bc569ee80e5",
				"formattedSize": "359.49 KB",
				"height": 2260,
				"name": "L-Cole-2023-8916-copy.jpg",
				"path": "uploads/about us/Features About/Feature 01 Image/L-Cole-2023-8916-copy.jpg",
				"query": "?as=run",
				"size": 368113,
				"type": "image/jpeg",
				"updated": "2026-04-04T03:10:18.425Z",
				"width": 1500
			}
		},
		"Feature 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"description": {
					"translations": {},
					"value": "### Thomas J Moore\n---\n\nI look for a limited number of cases that are worth my absolute best efforts.\n\nI don’t want to be everyone’s attorney.  \nI want cases that are worth my undivided attention.\n \nIf you want an attorney who knows who you are, knows your story,\nand won’t treat your case like it’s simply another file, let’s talk.\n\nIf your case warrants my absolute time, attention, and urgency, \nthen please contact me."
				}
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"featureContainerClass": {
					"translations": {},
					"value": "w-full m-auto"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "grid grid-cols-1 lg:grid-cols-2 gap-2 sm:gap-4"
				},
				"imageClass": {
					"translations": {},
					"value": "m-auto border-8 border-primary rounded"
				},
				"imageContainerClass": {
					"translations": {},
					"value": "p-16"
				}
			}
		},
		"index": 1,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "03"
		}
	},
	"PageBanner": {
		"bgImage": {
			"permission": "Admin",
			"translations": {},
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": "A wooden desk with a legal pad, pen, and a law book beside a gavel, symbolizing legal expertise. The background is softly blurred, suggesting a professional office setting with warm and inviting lighting."
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fabout%20us%2FPageBanner%2FbgImage%2FAboutUsBanner.jpg?alt=media&token=59a6f482-b6de-4ebe-9c47-d87f2d9131da",
				"formattedSize": "73.70 KB",
				"height": 497,
				"name": "AboutUsBanner.jpg",
				"path": "uploads/about us/PageBanner/bgImage/AboutUsBanner.jpg",
				"query": "?as=run",
				"size": 75473,
				"type": "image/jpeg",
				"updated": "2025-02-21T14:29:55.858Z",
				"width": 1597
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"bgImageClass": {
					"translations": {},
					"value": "w-full"
				},
				"contentClass": {
					"translations": {},
					"value": "bg-base-300 inline-block p-2 sm:p-4 md:p-6 xl:p-8 rounded mx-2 sm:mx-4"
				}
			}
		},
		"index": 2,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "02"
		},
		"subtitle": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "Criminal Lawyers Birmingham Office of Thomas Johnson Moore"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"en-US": "About Us"
			},
			"type": "TextInput",
			"value": "About Us"
		}
	},
	"SideBySide": {
		"description": {
			"permission": "Admin",
			"translations": {
				"en-US": "### Thomas J Moore\n---\n\nI look for a limited number of cases that are worth my absolute best efforts.\n\nI don’t want to be everyone’s attorney.  \nI want cases that are worth my undivided attention.\n \nIf you want an attorney who knows who you are, knows your story,\nand won’t treat your case like it’s simply another file, let’s talk.\n\nIf your case warrants my absolute time, attention, and urgency, \nthen please contact me."
			},
			"type": "TextArea",
			"value": "### Thomas J Moore\n---\n\nI look for a limited number of cases that are worth my absolute best efforts.\n\nI don’t want to be everyone’s attorney.  \nI want cases that are worth my undivided attention.\n \nIf you want an attorney who knows who you are, knows your story,\nand won’t treat your case like it’s simply another file, let’s talk.\n\nIf your case warrants my absolute time, attention, and urgency, \nthen please contact me."
		},
		"image": {
			"permission": "Admin",
			"translations": {},
			"type": "Image",
			"value": {
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Fabout%20us%2FSideBySide%2Fimage%2FL-Cole-2023-8916-copy.jpg?alt=media&token=190f32f7-a577-4bdf-a4cb-02e824220623",
				"formattedSize": "359.49 KB",
				"height": 2260,
				"name": "L-Cole-2023-8916-copy.jpg",
				"path": "uploads/about us/SideBySide/image/L-Cole-2023-8916-copy.jpg",
				"query": "?as=run",
				"size": 368113,
				"type": "image/jpeg",
				"updated": "2025-02-21T14:28:50.925Z",
				"width": 1500
			}
		},
		"index": 3
	}
}